import { render } from "./SummaryData.vue?vue&type=template&id=2ec3558f"
import script from "./SummaryData.vue?vue&type=script&lang=js"
export * from "./SummaryData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__